










import { Spinner } from "@goodless/components";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {
        Spinner
    }
})
export default class LoadingView extends Vue {
    @Prop({ default: "" })
    text!: string
}
